import React, { Component } from 'react'
import HighScores from '../HighScores/HighScores';

export default class Results extends Component {
    constructor() {
        super();
        this.state = {
            email: "",
            country: "",
            userName: "",
            phoneNumber: "",
            shareText: "",
            savedScore: false
        }
        let params = (new URL(document.location)).searchParams;
        this.smartName = params.get("smartName");
        this.smartType = params.get("smartType");
        this.imageUrl = "https://services.etin.space/july-campaign/generate.php?smartType=" + this.smartType + "&smartName=" + this.smartName
    }

    setUserName = (e) => {
        let userName = e.target.value
        if (userName.length) {
            this.setState({
                userName
            })
        }
    }

    setEmail = (e) => {
        let email = e.target.value
        if (email.length) {
            this.setState({ email })
        }
    }

    setCountry = (e) => {
        let country = e.target.value
        if (country.length) {
            this.setState({ country })
        }
    }

    setPhoneNumber = (e) => {
        let phoneNumber = e.target.value
        if (phoneNumber.length) {
            this.setState({ phoneNumber })
        }
    }

    saveHighScore = () => {
        console.log("Saving Score")
        if (this.state.userName.length && this.state.email.length) {
            fetch("https://teni-the-billionaire.firebaseio.com/high-scores.json", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    name: this.state.userName,
                    email: this.state.email,
                    country: this.state.country,
                    phoneNumber: this.state.phoneNumber,
                    score: this.props.score
                })
            })
                .then(this.setState({ savedScore: true }))
        }
    }

    componentDidMount() {
        let shareText = "Beat+that!+My+Highscore+is+" + this.props.score + "!+Play+@TeniEntertainer's+Who+Wants+to+be+a+Billionaire+Challenge+and+sign+up+for+@Bet9jaOfficial+to+stand+a+chance+of+winning+big!"
        this.setState({ shareText })
    }

    render() {
        const scoreSaver = <div className="form-group col-md-6 offset-md-3">
            <h3 className="col-sm-12 text-center">Please enter your name, email, phone number & country</h3>
            <input
                placeholder="Your Name*"
                onChange={this.setUserName}
                value={this.state.userName}
                id="name"
                name="name"
                type="text"
                className="form-control text-center mb-3"
                maxLength="10"
            />
            <input
                placeholder="Your Email"
                onChange={this.setEmail}
                value={this.state.email}
                id="email"
                name="email"
                type="text"
                className="form-control text-center mb-3"
            />
            <input
                placeholder="Your Phone"
                onChange={this.setPhoneNumber}
                value={this.state.phoneNumber}
                id="phoneNumber"
                name="phoneNumber"
                type="text"
                className="form-control text-center mb-3"
            />
            <input
                placeholder="Your Country"
                onChange={this.setCountry}
                value={this.state.country}
                id="country"
                name="country"
                type="text"
                className="form-control text-center mb-3"
            />
            <p className="col-12 text-center">Enter your name to save your high score!</p>
            <div className="col-12 text-center">
                <button className="btn btn-secondary" onClick={this.saveHighScore}>Save High Score</button>
            </div>
        </div>

        const scoreSaved = <div className="col-12"><h4 className="text-center">Score Saved!</h4></div>
        return (
            <section id="hero" className="d-flex align-items-center">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 mb-3 col-md-8 offset-md-2 text-center share-instructions">
                            <h1>Game Over!</h1>
                            <h2>{this.props.reason}</h2>
                            <h3>
                                Your score:
                            </h3>
                            <h3 class="score">
                                {this.props.score.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </h3>
                            <h3>
                                {this.props.message}
                            </h3>
                        </div>
                        {
                            !this.props.victory ? "" :
                                this.state.savedScore ? scoreSaved : scoreSaver
                        }
                        <div className="col-sm-12 mb-3 text-center">
                            <a href="/" className="btn btn-lg btn-secondary">Try Again!</a>
                        </div>

                        <div className="col-sm-12 text-center">
                            <h4>Share Your Score</h4>
                            <p>to stand a chance to win up to 1 Million Naira, Tickets and More</p>
                        </div>

                        <div className="col-sm-12 share-btns mb-3 text-center">
                            <div className="row align-items-center">
                                <div className="col-sm-6 mb-3 text-center">
                                    <a href="https://music.apple.com/ng/album/billionaire/1481587186?i=1481587189" className="btn btn-lg btn-secondary">Listen To My EP</a>
                                </div>
                                <div className="col-sm-6 mb-3 text-center">
                                    <a href="https://amplifiedtickets.com/events/teni-live-in-concert-billionaire-experience/" className="btn btn-lg btn-secondary">Buy Tickets to My Lagos show in December</a>
                                </div>
                            </div>
                            <a
                                href={"https://www.facebook.com/sharer/sharer.php?u=https://tenimakanaki.com&title=" + this.state.shareText + ""}
                                className="social facebook btn-floating"
                                target="_blank"
                            >
                                <i className="fab fa-facebook"></i>
                            </a>
                            &nbsp;
                        <a
                                href={"https://twitter.com/intent/tweet?text=" + this.state.shareText + "&url=https://tenimakanaki.com&hashtags=TeniWWTBAB,TeniXBet9ja,TeniLive,BillionaireExperience"}
                                className="social twitter btn-floating"
                                target="_blank"
                            >
                                <i className="fab fa-twitter"></i>
                            </a>
                            &nbsp;
                        <a
                                href={"whatsapp://send?text=" + this.state.shareText + " https://tenimakanaki.com"}
                                className="social whatsapp btn-floating"
                                target="_blank"
                            >
                                <i className="fab fa-whatsapp"></i>
                            </a>
                            &nbsp;
                    </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 mb-3 col-md-8 offset-md-2 text-center">
                            {/* <HighScores limit={10} /> */}
                            <div className="col-12 text-center">
                                <a href="/high-scores" className="btn-secondary btn-lg btn">View Top Fans!</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
